






























import { defineComponent, PropType } from "@vue/composition-api";
import { UserReferring } from "@scrile/api-provider/dist/api/UserReferringProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useSystemSettings from "@/hooks/useSystemSettings";
import { $t } from "@/lib/i18nHelpers";
import { getAbsUrl, shareUrl } from "@/lib/urlHelpers";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import ReferralsList from "./ReferralsList.vue";

export default defineComponent({
  name: "ReferralsView",
  components: { ReferralsList, BasePage, PageTitle, BaseButton },
  props: {
    loading: { type: Boolean, required: true },
    enableScroll: { type: Boolean, required: true },
    userReferrings: { type: Array as PropType<UserReferring[]>, required: true },
    userReferrerPercent: { type: Number, required: true },
  },
  setup() {
    const { getData } = useSystemSettings();
    const { authUserStrict } = useAuthUser();
    const shareClick = () => {
      return shareUrl(getAbsUrl(`/signup/?referral=${authUserStrict.value.id}`), $t("Link copied to clipboard"));
    };

    getData();

    return {
      shareClick,
    };
  },
});
